import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { apiClient } from "@/api/client";

import { auditFilterToQuery, type AuditFilterState } from "../lib/url-state";

import { auditKeys } from "./query-keys";

/**
 * GET /v1/audit-events — the global audit ledger list, filtered by URL state.
 * `event_id` (the detail-drawer's UI-only field) is stripped by
 * `auditFilterToQuery` itself and never reaches the request.
 */
export function useAuditEvents(filter: AuditFilterState) {
  // Memoized on `filter` identity so relative presets ("7d", etc.) resolve
  // "now" once per filter change rather than drifting on every re-render.
  const query = useMemo(() => auditFilterToQuery(filter), [filter]);

  return useQuery({
    queryKey: auditKeys.list(query),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/audit-events", { params: { query } });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
